import { addressValidations } from './address';
import { personalDetailsAdvisorOnboarding, qualificationValidations } from './advisor-onboarding';
import { bankDetailsValidations } from './bank-details';
import { commonValidations } from './commons';
import { companyDetailsValidations } from './company-details';
import { fcaDetailsValidations } from './fca-details';
import { keyIndividualsValidations } from './key-individuals';
import { loginValidations } from './login';
import { relatedPartiesValidations } from './related-parties';
import { taxDetailsValidations } from './tax-details';

export const fieldValidations = {
  ...loginValidations,
  ...addressValidations,
  ...companyDetailsValidations,
  ...keyIndividualsValidations,
  ...taxDetailsValidations,
  ...bankDetailsValidations,
  ...relatedPartiesValidations,
  ...fcaDetailsValidations,
  ...personalDetailsAdvisorOnboarding,
  ...qualificationValidations,

  // always on last
  ...commonValidations,
};
